<template>
  <div>
    <div class="angle t_l"></div>
    <div class="angle t_r"></div>
    <div class="angle b_l"></div>
    <div class="angle b_r"></div>
  </div>
</template>

<script>
export default {
  name: 'angleIcon'
};
</script>

<style lang="scss" scoped>
  @import "../../style/dataVisual/variable";
  .angle {
    position: absolute;
    width: 12px;
    height: 12px;
    /*z-index: 9999;*/
  }
  .t_l {
    top: -1px;
    left: -1px;
    border-top: 1px solid $blue_3;
    border-left: 1px solid $blue_3;
  }
  .t_r {
    top: -1px;
    right: -1px;
    border-top: 1px solid $blue_3;
    border-right: 1px solid $blue_3;
  }
  .b_l {
    bottom: -1px;
    left: -1px;
    border-left: 1px solid $blue_3;
    border-bottom: 1px solid $blue_3;
  }
  .b_r {
    bottom: -1px;
    right: -1px;
    border-right: 1px solid $blue_3;
    border-bottom: 1px solid $blue_3;
  }
</style>
